const fragment = `
  id
  community {
    id
    name
  }
  communityProductType {
    id
    community {
      id
      name
    }
    productType {
      id
      name
    }
  }
  project {
    id
    name
  }
  seller {
    __typename
    ... on User {
      id
      name
      email
      phones
    }
    ... on Team {
      id
      name
      activeUsersCount
    }
  }
`;

export const listSellersSpacesQuery = `
  query ListSellerSpaces(
    $filter: SellerSpaceFilterInput
  ) {
    items: listSellerSpaces(filter: $filter) {
      ${fragment}
    }
  }
`;

export const getSellerSpaceQuery = `
  query GetSellerSpace($id: Int!) {
    item: getSellerSpace(id: $id) {
      ${fragment}
    }
  }
`;

export const createSellerSpaceQuery = `
  mutation CreateSellerSpace($input: CreateSellerSpaceInput!) {
    item: createSellerSpace(input: $input) {
      ${fragment}
    }
  }
`;

export const updateSellerSpaceQuery = `
  mutation UpdateSellerSpace($input: UpdateSellerSpaceInput!) {
    item: updateSellerSpace(input: $input) {
      ${fragment}
    }
  }
`;

export const deleteSellerSpaceQuery = `
  mutation DeleteSellerSpace($id: Int!) {
    item: deleteSellerSpace(id: $id) {
      ${fragment}
    }
  }
`;
